import type { MouseEventHandler } from 'react'
import React, { useCallback, useContext, useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import GeoContext from 'contexts/geoContext'
import ModalContext from 'contexts/ModalContext'
import { PROMO_SPEND_EARN_REGION } from 'constants/tours'
import TourSpendEarnDetailModal from 'components/Tours/TourSpendEarnDetailModal'
import FormatCurrency from 'components/Common/FormatCurrency/FormatCurrency'
import Clickable from 'components/Common/Clickable'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import UrgencyLabel from 'LuxKit/Label/UrgencyLabel'
import Typography from 'LuxKit/Typography/Typography'

function TourPromoSpendEarnLabel() {
  const { currentRegionCode, currentCurrency } = useContext(GeoContext)
  const showModal = useContext(ModalContext)
  const creditEarnListRegion = PROMO_SPEND_EARN_REGION[currentRegionCode]

  const bestCreditEarn = useMemo<number>(() => {
    const creditEarnList = creditEarnListRegion ?? []
    if (creditEarnList.length) {
      return Math.max(...creditEarnList.map(creditEarn => creditEarn.earn))
    }
    return 0
  }, [creditEarnListRegion])

  const showSpendEarnDetail = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()
    showModal(<TourSpendEarnDetailModal spendEarnList={creditEarnListRegion} maxCredit={bestCreditEarn} />)
  }, [bestCreditEarn, creditEarnListRegion, showModal])

  return <Clickable onClick={showSpendEarnDetail}>
    <UrgencyLabel variant="critical2">
      <Typography format="propercase">
        <BodyTextBlock endIcon={<LineInfoCircleIcon />} variant="small" weight="bold">
          <FormattedMessage
            id="vq0aMn0np8"
            defaultMessage=" Up to <currency></currency> credit. Ends 10 Mar"
            description="Promo label showing maximum credit earn amount and end date"
            values={{
              currency: () => <FormatCurrency value={bestCreditEarn} currency={currentCurrency} />,
            }}
          />
        </BodyTextBlock>
      </Typography>
    </UrgencyLabel>
  </Clickable>
}
export default TourPromoSpendEarnLabel
